import React, { useMemo, PropsWithChildren } from 'react';
/**
 * RTL for emotion
 */
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import stylisRtl from 'stylis-rtl';
// import { isSSR } from '@front10/utils';

interface Props {
  direction: 'ltr' | 'rtl';
  componentName?: string;
  tenant?: string;
}

const EmotionCache = (props: PropsWithChildren<Props>) => {
  // const { children } = props;
  // if (isSSR()) {
  //   return <>{children} </>;
  // }
  return <Cache {...props} />;
};

const Cache = ({
  children,
  direction,
  componentName = 'as',
  tenant = 'COpa'
}: PropsWithChildren<Props>) => {
  const createCacheFn = useMemo(() => {
    const uid = `${componentName.toLowerCase()}-${tenant.toLowerCase()}-${direction}`
      .replace(/\s+/g, '')
      .replace(/_+/g, '-');
    if (direction === 'ltr') {
      return createCache({ key: uid });
    }
    return createCache({ key: uid, stylisPlugins: [stylisRtl] });
  }, [componentName, direction, tenant]);

  return (
    <CacheProvider key={direction} value={createCacheFn}>
      {children}
    </CacheProvider>
  );
};

export { EmotionCache };
